import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkerboard",
  "use": "checkerboard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"checkerboard\"><path d=\"M3 11v-1h8v1H3zm10-3V7H3v1h10z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 2a2 2 0 114 0l-1-.001A1 1 0 109 2h5c1.242 0 2 .755 2 2v10c0 1.244-.758 2-2 2H2c-1.242 0-2-.755-2-2V4c0-1.244.758-2 2-2h4zM1 14V4c0-.418.588-1 1-1h1v.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V3h1c.412 0 1 .582 1 1v10c0 .418-.588 1-1 1H2c-.412 0-1-.582-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol